import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import api from '../services/api';

export const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      accessToken: null,
      refreshToken: null,
      isAuthenticated: false,

      login: async (email, password) => {
        const response = await api.post('/auth/login', { 
          Email: email, 
          Password: password 
        });
        set({
          user: response.data.User,
          accessToken: response.data.Access_Token,
          refreshToken: response.data.Refresh_Token,
          isAuthenticated: true,
        });
        return response.data;
      },

      register: async (email, password, full_name) => {
        const response = await api.post('/auth/register', { 
          Email: email, 
          Password: password, 
          Full_Name: full_name 
        });
        set({
          user: response.data.User,
          accessToken: response.data.Access_Token,
          refreshToken: response.data.Refresh_Token,
          isAuthenticated: true,
        });
        return response.data;
      },

      logout: async () => {
        const { refreshToken } = get();
        try {
          await api.post('/auth/logout', { Refresh_Token: refreshToken });
        } catch (error) {
          console.error('Logout error:', error);
        }
        set({
          user: null,
          accessToken: null,
          refreshToken: null,
          isAuthenticated: false,
        });
      },

      refreshAccessToken: async () => {
        const { refreshToken } = get();
        if (!refreshToken) throw new Error('No refresh token');
        
        const response = await api.post('/auth/refresh', { Refresh_Token: refreshToken });
        set({ accessToken: response.data.Access_Token });
        return response.data.Access_Token;
      },

      fetchUser: async () => {
        const response = await api.get('/auth/me');
        set({ user: response.data });
        return response.data;
      },
    }),
    {
      name: 'auth-storage',
    }
  )
);
